import { makeStyles } from "tss-react/mui";
import { Grid, Tabs, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useState } from "react";
import config from "../../../config";
import MissionRequestDialog from "./missionrequest/MissionRequestDialog";
import NewRequestsSection from "./subpages/sent/NewRequestsSection";
import AcceptedRequestsSection from "./subpages/sent/AcceptedRequestsSection";
import RejectedRequestsSection from "./subpages/sent/RejectedRequestsSection";
import AllRequestsSection from "./subpages/sent/AllRequestsSection";
import { useEmployee } from "../../../providers/EmployeeProvider";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    tabs: {
      marginBottom: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    tabsSlim: {
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  })
);

export default function SentMissionRequestsPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { tabId } = useParams();
  const [requestId, setRequestId] = useState("");
  const { slim } = useDevice();

  const navigate = useNavigate();
  const onTabChange = useCallback((_, val) => navigate(!!tabId ? `../${val}` : `./${val}`, { relative: "path", replace: true }), [navigate, tabId]);

  const onOpenDialog = useCallback((params, ev) => {
    setRequestId(params.id);
  }, [navigate, tabId]);

  const onCloseDialog = useCallback(() => {
    setRequestId("");
  });

  return (
    <ResponsivePage
      title={t("missionRequests:sentTitle")}
      maxWidth={config.pageSize.large}
    >
      <Grid item xs={12}>
        <Tabs className={slim ? classes.tabsSlim : classes.tabs} value={tabId || "new"} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
          <Tab value="new" label={t("missionRequests:newRequestsTab")} />
          <Tab value="accepted" label={t("missionRequests:acceptedRequestsTab")} />
          <Tab value="rejected" label={t("missionRequests:rejectedRequestsTab")} />
          <Tab value="all" label={t("missionRequests:allRequestsTab")} />
        </Tabs>
      </Grid>

      {
        !tabId || tabId === "new" ? (
          <NewRequestsSection onRowClick={onOpenDialog} />
        ) : tabId === "accepted" ? (
          <AcceptedRequestsSection onRowClick={onOpenDialog} />
        ) : tabId === "rejected" ? (
          <RejectedRequestsSection onRowClick={onOpenDialog} />
        ) : (
          <AllRequestsSection onRowClick={onOpenDialog} />
        )
      }

      {!!requestId ? (
        <MissionRequestDialog entityId={requestId} onClose={onCloseDialog} openButton sent />
      ) : null}

    </ResponsivePage>
  );
}
